<template>
  <v-container grid-list-md fluid wrap class="pb-0 pt-1">
    <v-layout v-if="value" wrap>
      <v-flex sm8 v-if="showPickup">
        <pickup-point-list-select
          :key="pickupPoint"
          v-model="pickupPoint"
          label="Pickup Point"
          :outlined="outlinedInputs"
          @input="updateValue"
        ></pickup-point-list-select>
      </v-flex>
      <v-flex sm4 v-if="showPickup">
        <v-text-field
          v-model="pickupTime"
          :label="pickupTimeLabel"
          type="time"
          :outlined="outlinedInputs"
          @change="updateValue"
        ></v-text-field>
        <v-menu
          ref="pickupTime"
          v-model="pickupTimeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="pickupTime"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          v-if="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="pickupTime"
              :label="pickupTimeLabel"
              prepend-inner-icon="access_time"
              readonly
              v-bind="attrs"
              v-on="on"
              :outlined="outlinedInputs"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="pickupTimeMenu"
            v-model="pickupTime"
            full-width
            @click:minute="$refs.pickupTime.save(pickupTime)"
            @change="updateValue"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex sm8 v-if="showDropoff">
        <pickup-point-list-select
          :key="dropoffPoint"
          v-model="dropoffPoint"
          label="Dropoff Point"
          :is-dropoff="true"
          :outlined="outlinedInputs"
          @input="updateValue"
        ></pickup-point-list-select>
      </v-flex>
      <v-flex sm4 v-if="showDropoff">
        <v-text-field
          v-model="dropoffTime"
          :label="dropoffTimeLabel"
          type="time"
          :outlined="outlinedInputs"
          @change="updateValue"
        ></v-text-field>
        <v-menu
          ref="dropoffTime"
          v-model="dropoffTimeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="dropoffTime"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          v-if="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dropoffTime"
              :label="dropoffTimeLabel"
              prepend-inner-icon="access_time"
              readonly
              v-bind="attrs"
              v-on="on"
              :outlined="outlinedInputs"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="dropoffTimeMenu"
            v-model="dropoffTime"
            full-width
            @click:minute="$refs.dropoffTime.save(dropoffTime)"
            @change="updateValue"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex sm8 v-if="showRoomNumbers">
        <v-text-field
          label="Room Numbers"
          v-model="roomNumbers"
          @change="updateValue"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm4 v-if="showRoomNumbers">
        <v-text-field
          v-model="timeFrom"
          label="Time From"
          type="time"
          :outlined="outlinedInputs"
          @change="updateValue"
        ></v-text-field>
        <v-menu
          ref="timeFrom"
          v-model="timeFromMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="timeFrom"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          v-if="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="timeFrom"
              label="Time From"
              prepend-inner-icon="access_time"
              readonly
              v-bind="attrs"
              v-on="on"
              :outlined="outlinedInputs"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="timeFromMenu"
            v-model="timeFrom"
            full-width
            @click:minute="$refs.timeFrom.save(timeFrom)"
            @change="updateValue"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex sm12 v-if="showFlightNo">
        <v-text-field
          label="Flight No"
          v-model="flightNo"
          @change="updateValue"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm12>
        <v-text-field
          label="Confirmation No"
          v-model="confirmationNo"
          @change="updateValue"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm12>
        <v-textarea
          label="Itinerary Remarks"
          v-model="agentNotes"
          @change="updateValue"
          :outlined="outlinedInputs"
        ></v-textarea>
      </v-flex>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-flex sm12 v-bind="attrs" v-on="on">
            <v-text-field
              disabled
              label="Supplier Communication"
              v-model="supplierNotes"
              @change="updateValue"
              :outlined="outlinedInputs"
            >
            </v-text-field>
          </v-flex>
        </template>
        <span>{{ supplierNotes }}</span>
      </v-tooltip>
      <v-flex sm12>
        <v-textarea
          label="Voucher Notes"
          v-model="voucherNotes"
          @change="updateValue"
          :outlined="outlinedInputs"
        ></v-textarea>
      </v-flex>
      <v-flex sm12>
        <v-textarea
          label="Internal Notes"
          v-model="internalNotes"
          @change="updateValue"
          :outlined="outlinedInputs"
          disabled
        ></v-textarea>
      </v-flex>
    </v-layout>
    <div v-if="debug">
      <pre>{{ JSON.stringify(value) }} </pre>
      <br />
      {{ serviceType }}
    </div>
  </v-container>
</template>

<script>
import PickupPointListSelect from "../../../shared/PickupPointListSelect";
export default {
  name: "ItemRemarks",
  props: {
    value: {
      type: Object,
      default: null,
    },
    serviceType: {
      type: String,
      required: true,
    },
  },
  components: { PickupPointListSelect },
  data() {
    return {
      debug: false,
      dropoffTimeMenu: false,
      pickupTimeMenu: false,
      timeFromMenu: false,
      // Local variables for form fields
      pickupPoint: null,
      pickupTime: "",
      dropoffPoint: null,
      dropoffTime: "",
      roomNumbers: "",
      timeFrom: "",
      flightNo: "",
      confirmationNo: "",
      agentNotes: "",
      supplierNotes: "",
      voucherNotes: "",
      internalNotes: "",
    };
  },

  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          // Update local state when value prop changes
          this.pickupPoint = newVal.pickupPoint;
          this.pickupTime = newVal.pickupTime;
          this.dropoffPoint = newVal.dropoffPoint;
          this.dropoffTime = newVal.dropoffTime;
          this.roomNumbers = newVal.roomNumbers;
          this.timeFrom = newVal.timeFrom;
          this.flightNo = newVal.flightNo;
          this.confirmationNo = newVal.confirmationNo;
          this.agentNotes = newVal.agentNotes;
          this.supplierNotes = newVal.supplierNotes;
          this.voucherNotes = newVal.voucherNotes;
          this.internalNotes = newVal.internalNotes;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    showPickup() {
      return this.serviceType && this.serviceType != "ACCOMMODATION";
    },
    showDropoff() {
      return this.serviceType && this.serviceType != "ACCOMMODATION";
    },
    showRoomNumbers() {
      return this.serviceType && this.serviceType == "ACCOMMODATION";
    },
    showFlightNo() {
      return (
        this.serviceType &&
        (this.serviceType == "TRANSPORT" || this.serviceType == "TRAVEL")
      );
    },
    pickupTimeLabel() {
      return this.serviceType && this.serviceType == "ACTIVITY"
        ? "Start Time"
        : "Pickup Time";
    },
    dropoffTimeLabel() {
      return this.serviceType && this.serviceType == "ACTIVITY"
        ? "End Time"
        : "Dropoff Time";
    },
  },
  methods: {
    updateValue() {
      // Update timeFrom logic
      if (this.timeFrom && this.timeFrom.toString() != "") {
        this.pickupTime = this.timeFrom;
      }
      // Create payload from local variables
      const payload = {
        pickupPoint: this.pickupPoint,
        pickupTime: this.pickupTime,
        dropoffPoint: this.dropoffPoint,
        dropoffTime: this.dropoffTime,
        roomNumbers: this.roomNumbers,
        timeFrom: this.timeFrom,
        flightNo: this.flightNo,
        confirmationNo: this.confirmationNo,
        agentNotes: this.agentNotes,
        supplierNotes: this.supplierNotes,
        voucherNotes: this.voucherNotes,
        internalNotes: this.internalNotes,
      };

      //console.log("updateValue", payload);
      this.$emit("input", payload);
    },
    onChange() {
      this.updateValue();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/ItemRemarks.vue